import { useContext, useEffect, useRef, useState } from 'react';
import FormBuilder from '../../../../library/Builders/FormBuilder';
import { SmartContext } from '../../../../library/Core/SmartContext';
import { FormSection } from '../../../../library/Core/SmartTypes';
import FiltersApplied from '../../../../library/SimpleControls/FiltersApplied';
import InternalAdminGrievanceService, { defaultSearchCriteria } from '../services/InternalAdminGrievanceService';

const SearchCriteria = () => {
    const { state, dispatch } = useContext(SmartContext);
    const searchFormConfig = state.formConfig?.sectionRepository[0] as FormSection;

    const [fuzzySearchText, setFuzzySearchText] = useState('');
    const [isExpanded, setIsExpanded]           = useState(true);
    const lastFetchedCriteriaRef = useRef(state.data.searchCriteria);

    // Re-fetch only when searchCriteria VALUE changes (not on every parent re-render)
    useEffect(() => {
        if (lastFetchedCriteriaRef.current === state.data.searchCriteria) return;
        lastFetchedCriteriaRef.current = state.data.searchCriteria;

        InternalAdminGrievanceService.search(state.data.searchCriteria).then((response) => {
            dispatch({
                type: 'CONTROL_VALUE_CHANGE',
                payload: { dataKey: 'grievanceList', value: response.grievances ?? [], errorMessages: [] },
            });
            dispatch({
                type: 'CONTROL_VALUE_CHANGE',
                payload: { dataKey: 'tabCounts', value: response.tabCounts ?? state.data.tabCounts, errorMessages: [] },
            });
        });
    }, [state.data.searchCriteria]);

    const commitSearch = (text: string) => {
        dispatch({
            type: 'CONTROL_VALUE_CHANGE',
            payload: { dataKey: 'searchCriteria', value: { ...state.data.searchCriteria, search: text }, errorMessages: [] },
        });
    };

    const handleFuzzySearch = (event: React.FormEvent) => {
        event.preventDefault();
        commitSearch(fuzzySearchText);
    };

    const handleApply = () => commitSearch(fuzzySearchText);

    const handleClearAll = () => {
        const reset = defaultSearchCriteria();
        setFuzzySearchText('');
        dispatch({ type: 'CONTROL_VALUE_CHANGE', payload: { dataKey: 'searchCriteria', value: reset, errorMessages: [] } });
    };

    return (
        <>
            {/* ── Filter toggle row + fuzzy search ──────────────────────── */}
            <div className="row justify-content-between align-items-end align-items-sm-center flex-column-reverse flex-sm-row">
                <div className="col">
                    <div className="d-flex flex-wrap justify-content-between align-items-start align-items-md-center mb-2 filterSearch">
                        <div className="d-flex flex-wrap flex-1 mb-0 justify-content-start">
                            <button
                                className="btn-grpfiter me-3"
                                type="button"
                                aria-expanded={isExpanded}
                                onClick={() => setIsExpanded(!isExpanded)}
                            >
                                <i className="icon-filter font-13 me-2"></i>
                                Filters
                            </button>

                            <div className="search alumniSearch m-0 open position-static flex-1">
                                <form className="form-inline d-flex flex-wrap justify-content-between d-block" onSubmit={handleFuzzySearch}>
                                    <input
                                        type="search"
                                        value={fuzzySearchText}
                                        placeholder={searchFormConfig?.fuzzySearchPlaceholder ?? 'Grievance ID or Alumni Name'}
                                        aria-label="Search"
                                        className="form-control flex-1 font-13 font-500 text-truncate"
                                        onChange={(e) => setFuzzySearchText(e.target.value)}
                                    />
                                    <button className="btn btn-search icon icon-search" type="submit"></button>
                                </form>
                                <a href="javascript:;" className="btn-search-toggle icon-search"></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* ── Collapsible filter panel ───────────────────────────────── */}
            <div className="fitergroup mb-4">
                {isExpanded && (
                    <div className="accordion-collapse collapse show">
                        <div className="accordion-body p-4">
                            <FormBuilder key="searchCriteria" section={searchFormConfig} dataKey="searchCriteria" />

                            {/* Clear / Apply buttons */}
                            <div className="col-12 mt-3">
                                <div className="row g-3">
                                    {/* <div className="col-auto">
                                        <button
                                            className="btn btn-border-gray height-40 border-radius-6"
                                            type="button"
                                            onClick={handleClearAll}
                                        >
                                            <span className="line-height-16">Clear Filters</span>
                                        </button>
                                    </div> */}
                                    {/* <div className="col-auto">
                                        <button
                                            className="btn btn-darkblue border-radius-6"
                                            type="button"
                                            onClick={handleApply}
                                        >
                                            <span className="line-height-16">Apply Filters</span>
                                        </button>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* Applied filter pills */}
            <div className="filterresult">
                <FiltersApplied dataKey="searchCriteria" onClearAll={handleClearAll} />
            </div>
        </>
    );
};

export default SearchCriteria;
